import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBIcon,
} from "mdbreact";
import { Zoom, Fade } from "react-reveal";
import projects from "../../assets/img/presentation.png";
import training from "../../assets/img/education.png";
import events from "../../assets/img/fireworks.png";
import SingleCardStyle from "./SingleCardStyle.css";

const TestimonialsPage = (props) => {
  return (
    <div className="container">
      <div className="row equal-cols">
        <div className="col-md-4">
          <Fade duration={3000} left>
            <MDBCard testimonial className="card-custom">
              <div
                onClick={() => {
                  props.history.push(
                    window.language.currUrl(props.match, "projects")
                  );
                }}
              >
                <div color="info" />
                <div className="mx-auto white">
                  <img
                    src={projects}
                    alt=""
                    className="rounded-circle img-fluid"
                  />
                </div>
                <MDBCardBody>
                  <h4 className="font-weight-bold mb-4">{props.projects}</h4>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon icon="quote-left" className="pr-2" />
                    {props.projectsDesc}
                  </p>
                </MDBCardBody>
              </div>
            </MDBCard>
          </Fade>
        </div>
        <div className="col-md-4">
          <Zoom duration={2000}>
            <MDBCard testimonial className="card-custom">
              <div gradient="blue" />
              <div
                className="mx-auto white"
                onClick={() => {
                  props.history.push(
                    window.language.currUrl(props.match, "trainings")
                  );
                }}
              >
                <img
                  src={training}
                  alt=""
                  className="rounded-circle img-fluid"
                />
              </div>
              <MDBCardBody>
                <h4 className="font-weight-bold mb-4">{props.trainings}</h4>
                <hr />
                <p className="dark-grey-text mt-4">
                  <i className="fa fa-quote-left pr-2" />
                  {props.trainingsDesc}
                </p>
              </MDBCardBody>
            </MDBCard>
          </Zoom>
        </div>
        <div className="col-md-4">
          <Fade duration={3000} right>
            <MDBCard testimonial className="card-custom">
              <div className="indigo" />
              <div
                className="mx-auto white"
                onClick={() => {
                  props.history.push(
                    window.language.currUrl(props.match, "events")
                  );
                }}
              >
                <img src={events} alt="" className="rounded-circle img-fluid" />
              </div>
              <MDBCardBody>
                <h4 className="font-weight-bold mb-4">{props.events}</h4>
                <hr />
                <p className="dark-grey-text mt-4">
                  <i className="fa fa-quote-left pr-2" />
                  {props.eventsDesc}
                </p>
              </MDBCardBody>
            </MDBCard>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;



// WEBPACK FOOTER //
// ./src/components/FlippingCard/FlippingCard.jsx